/* The ai21 mark + product label, ported verbatim from the Claude Design mock so
 * the Overview header lockup matches the design (Aeonik Fono bracketed label). */
export function Wordmark({
  height = 20,
  color = "var(--text)",
  bracket = "var(--text-muted)",
  label = "Gateway",
}: {
  height?: number;
  color?: string;
  bracket?: string;
  label?: string;
}) {
  const fs = Math.round(height * 0.7 * 10) / 10;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: height * 0.42,
      }}
    >
      <svg
        height={height}
        viewBox="0 0 113 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
        aria-label="AI21"
      >
        <path
          d="M63.5077 37.5147H93.8581V27.9632H86.8659V30.5631H75.9543L85.8066 24.833C88.9844 22.9762 92.9569 19.3143 92.9569 13.3183C92.9569 5.67688 86.4951 0 78.4436 0C69.8632 0 63.5595 6.52624 63.6126 14.7512H71.3982V14.4322C71.3982 10.2399 74.4179 7.26926 78.4954 7.26926C82.5729 7.26926 85.3812 10.0286 85.3812 13.5842C85.3812 15.3347 84.6396 17.1398 81.9908 18.7839L63.5049 30.5099V37.5133L63.5077 37.5147ZM97.6711 37.5147H112.289V30.5113H108.952V0.370809H97.6697V7.3742H101.06V30.5085H97.6697V37.5119L97.6711 37.5147ZM45.499 37.5147H59.6415V30.5113H56.4106V7.3756H59.6415V0.370809H45.499V7.3742H48.7299V30.5085H45.499V37.5119V37.5147ZM18.9616 30.3504C12.7111 30.3504 7.5743 25.2038 7.5743 18.8889C7.5743 12.5739 12.7125 7.48055 18.9616 7.48055C25.2108 7.48055 30.244 12.5739 30.244 18.8889C30.244 25.2038 25.2122 30.3504 18.9616 30.3504ZM18.9616 37.8855C22.9874 37.8855 26.5891 36.6122 29.3429 34.1718L29.6605 33.9059V37.5147H41.101V30.5113H37.7106V7.3756H41.101V0.370809H29.6605V3.87321L29.3429 3.60734C26.5359 1.27334 22.9874 0 18.9616 0C8.58038 0 0 8.48943 0 18.942C0 29.3947 8.58038 37.8855 18.9616 37.8855Z"
          fill={color}
        />
      </svg>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: fs * 0.4,
          fontFamily: "'Aeonik Fono','JetBrains Mono',monospace",
          fontSize: fs,
          lineHeight: 1,
          color,
          letterSpacing: "0.01em",
          whiteSpace: "nowrap",
        }}
      >
        <span style={{ color: bracket, fontSize: fs * 1.2, fontWeight: 400 }}>
          [
        </span>
        {label}
        <span style={{ color: bracket, fontSize: fs * 1.2, fontWeight: 400 }}>
          ]
        </span>
      </span>
    </span>
  );
}
